import { Component, OnInit, HostListener, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from "@angular/forms";
import { StoragesService } from '@app/services/storages/storage.service';
import { ICategory } from '@app/models/category.interface';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StoragesCheckboxListComponent } from '@app/modules/storages/components/checkbox-list/checkbox-list.component';
import { IStorage } from '@app/models/storage.interface';
import { IArea } from '@app/models/area.interface';
import { IBarcode } from '@app/models/barcode.interface';
import { Observable, Subscription } from 'rxjs';
import { MasterCountCategoryService } from '@app/services/master-count-category/master-count-category.service';
import { first, map, skipWhile, startWith, take } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormComponent } from '@app/modules/organization/categories-table/form/form.component';
import { Store, select } from '@ngrx/store';
import { selectSettingsState } from '@app/modules/settings/store/selectors/settings.selectors';
import { selectOrganizationState } from '@app/modules/organization/store/selectors/organization.selectors';
import { SubSink } from 'subsink';
import * as StoragesActions from '@app/modules/storages/store/actions/storages.actions';
import * as OrganizationActions from '@app/modules/organization/store/actions/organization.actions';
import { MatChipInputEvent, MatChipList } from '@angular/material/chips';
import { BreakpointService } from '@app/services/breakpoint/breakpoint.service';
import { LimitAccessService } from '@app/core/services/limit-access.service';
import { selectMeState } from '@app/core/store/core.selectors';
import * as CoreActions from '@app/core/store/core.action';
import { TranslateService } from '@ngx-translate/core';
import { lang_selected$ } from '@app/shared/components/language-selector/language-selector.component';
import { selectStorageState, selectStoragesPathState } from '../store/selectors/storages.selectors';
import { ILocation } from '@app/models/location.interface';
import { LocationsService } from '@app/services/locations/locations.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-storage-add',
  templateUrl: './storage-add.component.html',
  styleUrls: ['./storage-add.component.scss']
})
export class StorageAddComponent implements OnInit {
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  public form: FormGroup;
  public QytLimitData$: any = 0;
  public storages$: IStorage[];
  public storage: IStorage;
  public isAllowedToLeave: boolean = true;
  public subs = new SubSink;
  public settings$;
  public currentLocID$;
  public readStorageOption: boolean = true;
  public disablePrimaryLocation: boolean = true;
  public isLoading: boolean = true;
  width_radio_text = '';
  close_button_margin = '';
  lang_selected: string;
  public subscription: Subscription;
  public searchControl = new FormControl();
  filteredStorages: any;
  public locations$: ILocation[];
  public storagesLoading: boolean = false;
  public parentStorageStructureID : any;
 
  
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return this.isAllowedToLeave;
  }

  constructor(
    private fb: FormBuilder,
    private _storages: StoragesService,
    private _matDialog: MatDialog,
    private _matDialogRef: MatDialogRef<StorageAddComponent>,
    private _master: MasterCountCategoryService,
    private store$: Store,
    public _translation: TranslateService,
    private _breakpoints: BreakpointService,
    private limitAccessService: LimitAccessService,
    private _locations: LocationsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      description: new FormControl(''),
      parentID: new FormControl(''),
      sortOrder: new FormControl(''),
      locationID: new FormControl('')
    });

    this.searchControl.disable();
    this._locations.onMyLocations('locName', 'asc').subscribe((res:any) => { 
      // this.locations$ = res.data.locations.map(location => {
      //   return {
      //     ...location
      //   };
      // });

      //if(this.locations$.length==1){
      this.currentLocID$ = this.data.locID;
        // this.store$.subscribe((state: any) => {
        //   this.currentLocID$ = state.core?.me?.locID;
        // });

        this._storages.getStoragesPath(0, this.currentLocID$).subscribe((storages) => {

          if(storages.storages!=null && storages.storages.length>0){
            this.storages$ = storages.storages;
            this.filteredStorages = this.searchControl.valueChanges.pipe(
              startWith(''),
              map(state => state ? this.filterStates(state) : storages.storages.slice())
            );
            this.searchControl.enable();
          }
          this.parentStorageStructureID = this.data.parentStorageStructureID;
          
          this.searchControl.setValue(this.data.currentAddTitle);
          this.form.get('parentID').setValue(this.data.parentStorageStructureID);
          //this.form.get('parentID').setValue(this.data.parentStorageStructureID);
          this.isLoading = false;

        });
      //}
      
    });
  } 
  
  ngOnInit(): void {

    this.subscription = lang_selected$.subscribe(value => {
      this.lang_selected = value;
      if (this.lang_selected != 'en-ca') {
        this.width_radio_text = 'width_radio_text';
        this.close_button_margin = 'close_button_margin';
      } else {
        this.width_radio_text = '';
        this.close_button_margin = '';
      }
    });

    this.limitAccessService.arraySettingAccess$.subscribe((arraySettingAccess) => {
      if (arraySettingAccess) {
        this.readStorageOption = this.limitAccessService.getAccess('warehouse', 'storages', '','');
      }
    });

    this.form.valueChanges.subscribe(() => this.isAllowedToLeave = false);

  }


  ngOnDestroy() {
    this.subs.unsubscribe()
    this.form.reset();
    this.store$.dispatch(StoragesActions.resetStorage());
    this._storages.onSetIsAllowedToLeave(true);
  }

  async onSubmit() {
    this.isAllowedToLeave = true;
    this.form.get('locationID').setValue(this.currentLocID$);
    this._storages.onSave(this.form.value).subscribe((response) => {
      if(response!=null && response.storage!=null && response.storage!='undefined'){
        this._matDialogRef.close(response.storage);
      }
      else if(response?.data?.toastr?.key === 'toastr.createStorageExist'){
        // Duplicate top-level (parent) name — keep the dialog open so the user can rename.
        this.store$.dispatch(CoreActions.showErrorMessage({
          title: this._translation.instant('errormessage.warning'),
          body: this._translation.instant('toastr.createStorageExist', { storage: this.form.get('name').value }),
          show_upgrade: false
        }));
      }
      else{
        this.store$.dispatch(CoreActions.showErrorMessage({
          title: this._translation.instant('errormessage.warning'),
          body: this._translation.instant('anErrorOcurred'),
          show_upgrade: false
        }));

      }
      
      // if(response.error){
      //   this.store$.dispatch(CoreActions.showErrorMessage({
      //     title: this._translation.instant('errormessage.warning'),
      //     body: this._translation.instant('errormessage.error')
      //   }));
      // }
      // else{
      //   this.store$.dispatch(StoragesActions.saveStorage({ form: this.form.value }))
      //   this.store$.dispatch(StoragesActions.loadStorages({query:''}));
      //   this._matDialogRef.close(this.form.value);
      // }
    });

    //this.store$.dispatch(StoragesActions.loadStorages({query:''}));
    
  }

  noWhitespaceValidator(control) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  filterStates(name: any) {
    var names = name;
    if(name?.name!=null && name.name!='undefined'){
      names = name.name;
    }
    // The input mirrors the full storage path ("Floor 1 -> Shelf B"), so a
    // prefix match against the bare name never hits once a node is nested.
    // The list's `path` already ends with the node's own name (a root's path
    // IS its name), so matching anywhere in the path covers both.
    const filterValue = this._normalizeValue(String(names ?? ''));
    return this.storages$.filter(state => this._normalizeValue(String(state.path ?? state.name ?? '')).includes(filterValue));

  }

  onOptionSelection(storageStructureID: any) {
    this.form.get('parentID').setValue(storageStructureID);
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  // onLocationChange(event: MatSelectChange) {
  //   this.storagesLoading = true;
  //   this.searchControl.disable();
  //   this.form.get('parentID').setValue('');

  //   this.currentLocID$ = event.value;

  //   this._storages.getStoragesPath(0, this.currentLocID$).subscribe((storages) => {
  //     this.storages$ = storages.storages;

  //     this.filteredStorages = this.searchControl.valueChanges.pipe(
  //       startWith(''),
  //       map(state => state ? this.filterStates(state) : storages.storages.slice())
  //     );
      
  //     this.searchControl.enable();
  //     this.storagesLoading = false;
  //   });

  //   this.searchControl.setValue('');
  // }
  cancel(){
    this._matDialogRef.close();
  }
  // clearInput() {
  //   this.searchControl.reset();
  // }

}
